<template>
    <div class="patient-card" :class="{ 'patient-card--birthday': showBirthdayMessage, 'patient-card--detailed': detailed }" data-testid="patient-card">
        <div v-if="detailed && $slots.header" class="patient-card__header">
            <slot name="header" />
        </div>
        <div class="patient-card__main">
            <figure class="patient-card__avatar">
                <!--suppress HtmlUnknownTarget -->
                <img v-if="photo" :alt="name" :src="`/assets/attachments/thumbnails/${photo}`" class="patient-card__photo">
                <frm-icon v-else name="patient" class="patient-card__icon" />
            </figure>
            <div class="patient-card__content">
                <h3 class="patient-card__name" :title="name">
                    {{ name }} <span v-if="gender && !detailed">({{ $t(`patient.values.gender-denotation-${gender}`) }})</span>
                </h3>
                <dl v-if="!detailed" class="patient-card__details">
                    <dt v-if="birthdate" class="patient-card__detail-title" v-text="$t('patient.fields.birthdate')" />
                    <dd v-if="birthdate" class="patient-card__detail-description">
                        {{ $ds(birthdate, 'date') }}
                        <frm-deceased-icon v-if="deceasedDate" :date="$ds(deceasedDate, 'date')" />
                    </dd>
                    <dt v-if="identificationNumber" class="patient-card__detail-title" v-text="$t('patient.fields.identification_number')" />
                    <dd v-if="identificationNumber" class="patient-card__detail-description" v-text="identificationNumber" />
                </dl>
                <dl v-else class="patient-card__detail-list definition-list">
                    <div v-if="identificationNumber" class="definition-list__group">
                        <dt class="definition-list__term" v-text="$t('patient.fields.identification_number')" />
                        <dd class="definition-list__definition" v-text="identificationNumber" />
                    </div>
                    <div v-if="birthdate" class="definition-list__group">
                        <dt class="definition-list__term" v-text="$t('patient.fields.birthdate')" />
                        <dd class="definition-list__definition">
                            {{ $ds(birthdate, 'date') }}
                            <frm-deceased-icon v-if="deceasedDate" :date="$ds(deceasedDate, 'date')" />
                        </dd>
                    </div>
                    <div v-if="gender" class="definition-list__group">
                        <dt class="definition-list__term" v-text="$t('patient.fields.gender')" />
                        <dd class="definition-list__definition" v-text="$t(`patient.values.gender-denotation-${gender}`)" />
                    </div>
                    <div v-if="hasAddress" class="definition-list__group">
                        <dt class="definition-list__term" v-text="$t('masterfiles.fields.address')" />
                        <dd class="definition-list__definition">
                            <span v-if="addressStreetLine" v-text="addressStreetLine" />
                            <span v-if="addressCityLine" v-text="addressCityLine" />
                        </dd>
                    </div>
                </dl>
            </div>
            <div v-if="$slots.actions" class="patient-card__actions">
                <slot name="actions" />
            </div>
        </div>
        <div v-if="detailed && $slots.footer" class="patient-card__footer">
            <slot name="footer" />
        </div>
        <div v-if="showBirthdayMessage" class="patient-card__birthday patient-card__birthday--animate" data-testid="patient-card:birthday">
            <frm-icon name="balloon" class="patient-card__birthday-icon" />
            <span class="patient-card__birthday-text">
                {{ $t('patient.messages.birthday_on') }}
                <strong>{{ $ds(birthdate, 'dateShort') }}</strong>
            </span>
            <frm-icon name="balloon" class="patient-card__birthday-icon" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                required: true,
            },

            birthdate: {
                type: String,
                default: null,
            },

            deceasedDate: {
                type: String,
                default: null,
            },

            gender: {
                type: String,
                default: null,
            },

            identificationNumber: {
                type: String,
                default: null,
            },

            detailed: {
                type: Boolean,
                default: false,
            },

            address: {
                type: Object,
                default: () => ({}),
            },

            photo: {
                type: [String, Number],
                default: null,
            },

            eventDate: {
                type: String,
                default: null,
            },
        },

        methods: {
            isBirthday(otherDate) {
                const birthdate = new Date(this.birthdate);

                return otherDate.getDate() === birthdate.getDate() && otherDate.getMonth() === birthdate.getMonth();
            },

            today() {
                if (sessionStorage.getItem('MOCK_PATIENT_CARD_TODAY')) {
                    return new Date(sessionStorage.getItem('MOCK_PATIENT_CARD_TODAY'));
                }

                return new Date();
            },
        },

        computed: {
            addressStreetLine() {
                return [
                    this.address.street,
                    [this.address.house_number, this.address.house_number_suffix].filter(Boolean).join(' '),
                ].filter(Boolean).join(' ');
            },

            addressCityLine() {
                return [this.address.postal_code, this.address.city].filter(Boolean).join(' ');
            },

            hasAddress() {
                return Boolean(this.addressStreetLine || this.addressCityLine);
            },

            showBirthdayMessage() {
                if (!this.birthdate || this.deceasedDate) {
                    return false;
                }

                return this.isBirthday(this.today()) || this.isBirthday(new Date(this.eventDate));
            },
        },
    };
</script>
